import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ReasonWhySection } from '../components/ReasonWhySection';
import { BenefitsSection } from '../components/BenefitsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductInUseSection } from '../components/ProductInUseSection';
import { ProblemAwarenessSection } from '../components/ProblemAwarenessSection';
import { MaterialsSection } from '../components/MaterialsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { JourneyTimelineSection } from '../components/JourneyTimelineSection';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { WhyFivePackSection } from '../components/WhyFivePackSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
import { SocialProofNotifications } from '../components/ui/SocialProofNotifications';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-567">
      <HeroSection data-id="element-568" />
      <ReasonWhySection data-id="element-569" />
      <BenefitsSection data-id="element-570" />
      <MechanismSection data-id="element-571" />
      <ProductInUseSection data-id="element-572" />
      <ProblemAwarenessSection data-id="element-573" />
      <MaterialsSection data-id="element-574" />
      <TestimonialsSection data-id="element-575" />
      <JourneyTimelineSection data-id="element-576" />
      <DifferentiationSection data-id="element-577" />
      <BonusSection data-id="element-578" />
      <PricingSection data-id="element-579" />
      <WhyFivePackSection data-id="element-580" />
      <FAQSection data-id="element-581" />
      <GuaranteeSection data-id="element-582" />
      <Footer data-id="element-583" />

      {/* Social Proof Notifications */}
      <SocialProofNotifications data-id="element-584" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden z-50" data-id="element-585">
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full bg-[#1E40AF] text-white font-bold py-3 px-6 rounded-full shadow-lg" data-id="element-586">
          Get SnoreStop™ Now
        </button>
      </div>
    </div>;
}